import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBarsProgress, faBox, faCartShopping, faChartLine, faChevronDown, faChevronRight, faCubes, faDatabase, faEthernet, faFileInvoiceDollar, faGear, faGlobe, faHdd, faHouse, faLayerGroup, faNetworkWired, faServer, faShieldAlt, faTicket, faTicketSimple, faUserGroup, faUserTie, faSitemap, faClipboardUser } from '@fortawesome/free-solid-svg-icons'

library.add(faHouse, faServer, faGear, faFileInvoiceDollar, faNetworkWired, faHdd, faShieldAlt, faTicketSimple, faLayerGroup, faUserGroup, faCartShopping, faChartLine, faBox, faUserTie, faTicket, faCubes, faBarsProgress, faEthernet, faGlobe, faDatabase, faChevronRight, faChevronDown, faSitemap, faClipboardUser)

createApp(App)
    .use(router)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app')
